import {
  getCourseCodePatternUrl,
  getCourseLevelUpdateProgressUrl,
} from "../config/Config";
import { getRequest, postRequest } from "./ServiceHelper";

export class CourseLevelService {
  static getCourseLevels = () => {
    return CourseLevelService.getCourseCodePattern().then((pattern) => {
      return pattern && pattern.length && pattern[0].courseLevels
        ? pattern[0].courseLevels
        : [];
    });
  };

  static getCourseCodePattern = () => {
    return getRequest(getCourseCodePatternUrl());
  };

  static getCourseLevelUpdateProgress = () => {
    return getRequest(getCourseLevelUpdateProgressUrl());
  };

  static createCourseCodePattern = (codePattern) => {
    return postRequest(getCourseCodePatternUrl(), codePattern);
  };
}
